<template>
    <div class="buyflow-panel">
        <div class="text-lg font-bold">
            Your current selection contains
        </div>
        <div class="flex
                    flex-row
                    justify-center
                    items-center
                    py-4">
            <span class="text-5xl
                         font-heavy
                         leading-none
                         text-salmon">
                {{ channelCount }}
            </span>
            &nbsp; channels
        </div>
        <div>
            <button
                @click.prevent="$emit('show-channel-lineup')"
                class="buyflow-button w-full flex items-center"
            >
                <IconEye class="mr-1" />
                Preview Channel Lineup
            </button>
        </div>
    </div>
</template>

<script>
    import IconEye from "@/atoms/icons/IconEye"
    export default {
        name: 'TVChannelCounter',
        components: {
            IconEye,
        },
        props: {
            channelCount: {
                type: Number,
                // required: true,
                default: 69,
            },
        },
    }
</script>
